function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5044 10.0059C22.8858 10.7018 21.147 13.7926 21.0744 13.9238C21.0252 14.0129 20.9994 14.1043 20.9994 14.205V16.6046H28.198V10.6057C28.198 10.4323 28.1254 10.2707 27.9918 10.1558C27.8582 10.041 27.6755 9.98008 27.5044 10.0059ZM20.9994 17.8043C20.3035 17.8043 19.7996 18.3081 19.7996 19.0041V28.6022H29.3978V19.0041C29.3978 18.3081 28.894 17.8043 28.198 17.8043H20.9994ZM19.7996 29.802C18.8084 29.802 18 30.6104 18 31.6016V38.2004C18 39.1916 18.8084 40 19.7996 40H29.3978C30.389 40 31.1974 39.1916 31.1974 38.2004V31.6016C31.1974 30.6104 30.389 29.802 29.3978 29.802H19.7996Z"
});

function SvgIc340D4850018C11Ec9A030242Ac130003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc340D4850018C11Ec9A030242Ac130003);
export default ForwardRef;